import { Preferences } from "@capacitor/preferences";
import { isNative } from "@/platform";
import type { StateStorage } from "zustand/middleware";

/**
 * Zustand persist storage engine that uses Capacitor Preferences on native
 * and falls back to localStorage on web. Survives WebView session resets on iOS
 * where localStorage can be cleared by the OS under memory pressure.
 */
export const capacitorStorage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    if (!isNative()) return localStorage.getItem(name);
    const { value } = await Preferences.get({ key: name });
    return value;
  },
  setItem: async (name: string, value: string): Promise<void> => {
    if (!isNative()) {
      localStorage.setItem(name, value);
      return;
    }
    await Preferences.set({ key: name, value });
  },
  removeItem: async (name: string): Promise<void> => {
    if (!isNative()) {
      localStorage.removeItem(name);
      return;
    }
    await Preferences.remove({ key: name });
  },
};
